// [INÍCIO] Contratos da IA sob demanda e da cota por escola (ADR 0081, 0083)
import { z } from 'zod'

export const COTA_RESUMOS_PADRAO = 50
export const COTA_ANALISES_PADRAO = 4
export const TETO_LOTE_RESUMOS = 30

const dataIso = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'use AAAA-MM-DD')

export interface FaixaDeCotaDto {
  incluso: number
  extra: number
  usado: number
  /** Nulo na mesa FaroEscolar: não tem teto. */
  restante: number | null
}

export interface CotaIaDto {
  competencia: string
  ilimitada: boolean
  resumos: FaixaDeCotaDto
  analises: FaixaDeCotaDto
}

export const gerarResumosSchema = z.object({
  de: dataIso,
  ate: dataIso,
  funilId: z.string().uuid().optional(),
  chamadoIds: z.array(z.string().uuid()).max(TETO_LOTE_RESUMOS).optional(),
  tamanhoLote: z.number().int().min(1).max(TETO_LOTE_RESUMOS).optional(),
  soPendentes: z.boolean().optional(),
})
export type GerarResumosEntrada = z.infer<typeof gerarResumosSchema>

export interface ItemDoLoteIaDto {
  chamadoId: string
  ok: boolean
  modelo: string | null
  motivo: string | null
}

export interface ResultadoLoteIaDto {
  gerados: number
  pulados: number
  erros: number
  esgotadoGoogle: boolean
  cota: CotaIaDto
  itens: ItemDoLoteIaDto[]
}

export const gerarAnaliseSchema = z.object({
  de: dataIso,
  ate: dataIso,
})
export type GerarAnaliseEntrada = z.infer<typeof gerarAnaliseSchema>

export type OrigemEixoIa = 'perfil' | 'analise'

export interface AnaliseIaDto {
  texto: string
  modelo: string | null
  criadoEm: string
  de: string
  ate: string
  /** Eixos inventados nesta rodada. A próxima análise substitui. */
  eixos: EixoIaDto[]
}

export const periodoIaSchema = z.object({
  de: dataIso,
  ate: dataIso,
})

export interface LinhaEixoIaDto {
  valor: string
  rotulo: string
  conversas: number
  ganhas: number
  taxa: number | null
}

export interface EixoIaDto {
  eixo: string
  titulo: string
  origem: OrigemEixoIa
  linhas: LinhaEixoIaDto[]
}

export interface EstatisticasIaDto {
  cota: CotaIaDto
  /** Papel, etapa, motivo, urgência e confirmação das conversas resumidas. */
  eixos: EixoIaDto[]
  analise: AnaliseIaDto | null
  conversas: number
  comPerfil: number
  confirmadas: number
}

export const ajustarCotaSchema = z.object({
  cotaIaResumos: z.number().int().min(0).max(10_000).optional(),
  cotaIaAnalises: z.number().int().min(0).max(1_000).optional(),
  extraResumos: z.number().int().min(1).max(10_000).optional(),
  extraAnalises: z.number().int().min(1).max(1_000).optional(),
})
export type AjustarCotaEntrada = z.infer<typeof ajustarCotaSchema>
// [FIM] Contratos da IA sob demanda e da cota por escola (ADR 0081, 0083)
